import { render, staticRenderFns } from "./NewChip.vue?vue&type=template&id=b86c1bb2&scoped=true"
import script from "./NewChip.vue?vue&type=script&lang=js"
export * from "./NewChip.vue?vue&type=script&lang=js"
import style0 from "./NewChip.vue?vue&type=style&index=0&id=b86c1bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86c1bb2",
  null
  
)

export default component.exports